import { endpoints } from '@/api/endpoints.ts'
import { axiosAPI } from '@/api/repository/repository.ts'
import { FamilyGroup } from '@/model/family-group.ts'

function mapFamilyGroup (d: any): FamilyGroup {
  return new FamilyGroup(d.id, d.name, d.owner_id, d.members_details)
}

class FamilyGroupRepository {
  async list (): Promise<FamilyGroup[]> {
    const response = await axiosAPI.get(`${endpoints.familyGroup}`)
    return response.data.map((d: any) => mapFamilyGroup(d))
  }

  async getFamilyGroup (familyGroupId: string): Promise<FamilyGroup> {
    const response = await axiosAPI.get(`${endpoints.familyGroup}/${familyGroupId}`)
    return mapFamilyGroup(response.data)
  }

  async createFamilyGroup (data: { name: string }): Promise<FamilyGroup> {
    const response = await axiosAPI.post(`${endpoints.familyGroup}`, data)
    return mapFamilyGroup(response.data)
  }

  async updateFamilyGroup (familyGroupId: string, data: { name: string }): Promise<FamilyGroup> {
    const response = await axiosAPI.put(`${endpoints.familyGroup}/${familyGroupId}`, data)
    return mapFamilyGroup(response.data)
  }

  async deleteFamilyGroup (familyGroupId: string): Promise<void> {
    await axiosAPI.delete(`${endpoints.familyGroup}/${familyGroupId}`)
  }

  async addMember (familyGroupId: string, email: string): Promise<void> {
    await axiosAPI.put(`${endpoints.familyGroup}/${familyGroupId}/members`,
      {
        user_email: email,
      })
  }

  async removeMember (familyGroupId: string, email: string): Promise<void> {
    await axiosAPI.delete(`${endpoints.familyGroup}/${familyGroupId}/members/${encodeURIComponent(email)}`)
  }
}

export const familyGroupRepository = new FamilyGroupRepository()
